import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface BulkImportSolidsOverlayProps {
  currentIndex: number;
  totalSolids: number;
  currentSolidName: string;
  drawerOpen: boolean;
}

const BulkImportSolidsOverlay = ({
  currentIndex,
  totalSolids,
  currentSolidName,
  drawerOpen,
}: BulkImportSolidsOverlayProps) => {
  if (drawerOpen) return null;

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 20,
        p: 1.5,
        minWidth: 180,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Chip
          label={`${currentIndex + 1} / ${totalSolids}`}
          size="small"
          color="primary"
        />
        <Typography variant="body2" noWrap sx={{ maxWidth: 160 }}>
          {currentSolidName}
        </Typography>
      </Box>
    </Paper>
  );
};

export default BulkImportSolidsOverlay;
